<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: lc
 * @LastEditTime: 2023-07-03 11:28:06
-->
<template>
  <div class="add-danwei">
    <el-form ref="ruleForm"
             :model="viewData"
             :rules="rules"
             label-width="100px">
      <el-form-item label="广告位"
                    prop="pos_id">
        <el-select v-model="viewData.pos_id"
                   size="mini"
                   placeholder="请选择">
          <el-option v-for="(item, index) in selectList"
                     :key="index"
                     :label="item.name"
                     :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="名称"
                    prop="title">
        <el-input size="mini"
                  v-model="viewData.title" />
      </el-form-item>
      <el-form-item label="图片">
        <image-upload ref="imageUpload"
                      v-if="showUpload"
                      :tipInfo="'图片大小不超过20M,请自己处理好宽高比例,建议尺寸1:1'"
                      :image-list="imageDefaultList"
                      @updateImg="onUpdateImg($event)"></image-upload>
        <!-- <el-tabs v-model="activeType">
          <el-tab-pane label="图片"
                       name="1">
            <image-upload ref="imageUpload"
                          v-if="showUpload"
                          :tipInfo="'图片大小不超过20M,请自己处理好宽高比例,建议尺寸1:1'"
                          :image-list="imageDefaultList"
                          @updateImg="onUpdateImg($event)"></image-upload>
          </el-tab-pane>
          <el-tab-pane label="视频"
                       name="2">
            <uploadVideo ref="uploadVideo"
                         tipInfo="视频支持mp4格式"
                         :image-list="videoDefaultList"></uploadVideo>
          </el-tab-pane>
        </el-tabs> -->
      </el-form-item>
      <el-form-item label="跳转链接"
                    prop="name">
        <el-input size="mini"
                  v-model="viewData.url" />
      </el-form-item>
      <el-form-item label="排序"
                    prop="name">
        <el-input-number size="mini"
                         style="width: 100px"
                         v-model="viewData.sort"
                         controls-position="right"
                         :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="状态"
                    prop="sort">
        <el-switch size="mini"
                   v-model="viewData.status"
                   class="drawer-switch"
                   active-color="#13ce66"
                   inactive-color="#ff4949"
                   :active-value="true"
                   :inactive-value="false" />
      </el-form-item>
    </el-form>
    <div class="fix-fotter">
      <el-button style="min-width: 117px; background: #1067e0; font-size: 16px"
                 size="mini"
                 type="primary"
                 @click="tijiao('ruleForm')">提交</el-button>
    </div>
  </div>
</template>

<script>
import ad from "@/api/console/ad";
import ImageUpload from '@/components/Upload/image'
import uploadVideo from '@/components/UploadVideo/index'
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
  data () {
    return {
      showUpload: false, // 控制图片回显的闪;表现是第一次不闪，第2次闪 第3次闪,那问题是 el-upload上一个实例没有清除
      // 图片 视频 tab切换
      activeType: '1',
      // 图片上传组件默认图片
      imageDefaultList: '',
      thumbList: [], // 图片暂存
      videoDefaultList: [],//视频组件默认显示
      videoList: [], //视频暂存
      // 下拉选择广告位
      selectList: [],
      viewData: {
        ad_id: "",
        pos_id: "",
        title: "",
        thumb: "",
        type: 1,
        url: "",
        sort: 0,
        status: 1,
      },
      rules: {
        pos_id: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ]
      },
    };
  },
  components: {
    Pagination,
    ImageUpload,
    uploadVideo
  },
  created () { },
  methods: {
    /**
 * @name: 图片更新
 * @param {*} val
 * @return {*}
 * @desc: 
 */
    onUpdateImg (val) {
      let thumbList = [];
      val.forEach((ele, idx) => {
        thumbList.push({
          url: ele.path,
          filetype: ele.filetype
        })
      });
      this.thumbList = thumbList;
      // console.log('图片更新==',this.thumbList);
    },
    /**
     * @name: 广告位
     * @return {*}
     * @desc:
     */
    getselectList () {
      ad.select().then((res) => {
        if (res.code == 200) {
          this.selectList = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /**
     * @name: 初始化列表
     * @param {*} obj
     * @return {*}
     * @desc:
     */
    initFun (obj) {
      let that = this;
      this.showUpload = false;
      this.activeType = '1';
      this.imageDefaultList = '';
      this.videoDefaultList = [];
      this.thumbList = [];
      this.viewData = {
        ad_id: "",
        pos_id: "",
        title: "",
        thumb: "",
        type: 1,
        url: "",
        sort: 0,
        status: 1,
      };
      this.getselectList();
      this.showUpload = true;
      if (obj.id) {
        // 编辑
        this.viewData.ad_id = obj.id;
        this.showUpload = true;
        ad.bannerDetail({ ad_id: obj.id }).then((res) => {
          if (res.code == 200) {
            that.viewData = res.result;
            that.viewData.ad_id = res.result.id;
            that.activeType = res.result.type + ''

            let imgList = [];
            let videoList = [];
            if (that.viewData.thumb) {
              let imgList = []
              let obj = {
                name: that.viewData.thumb,
                path: that.viewData.thumb,
                url: this.$publicData.imgUrl + that.viewData.thumb,
              }
              imgList.push(obj);
              // 案件带的 回显图
              that.imageDefaultList = JSON.stringify(imgList);
            }
            // if (that.activeType == 1) {
            //   let obj = {
            //     nname: res.result.thumb,
            //     path: res.result.thumb,
            //     url: that.$publicData.imgUrl + res.result.thumb,
            //   }
            //   imgList.push(obj);
            // } else {
            //   let obj = {
            //     name: res.result.thumb,
            //     path: res.result.thumb,
            //     url: that.$publicData.imgUrl + res.result.thumb,
            //   }
            //   videoList.push(obj);
            // }
            // 回显图
            // that.imageDefaultList = JSON.stringify(imgList);
            // that.videoDefaultList = videoList;
          }
        });
      } else {
        // 新增
      }
    },
    /**
     * @name: 提交
     * @param {*} formName
     * @return {*}
     * @desc:
     */
    tijiao (formName) {
      let that = this;
      this.viewData.type = this.activeType
      this.viewData.thumb = this.thumbList[0] ? this.thumbList[0].url : ''
      // if (this.activeType == 1) {
      //   this.viewData.thumb = this.$refs.imageUpload.fileListTemp.length > 0 ? this.$refs.imageUpload.fileListTemp[0].path : ''
      //   if (!this.viewData.thumb) {
      //     this.$message.warning('请上传图片');
      //     return
      //   }
      // } else {
      //   this.viewData.thumb = this.$refs.uploadVideo.fileList.length > 0 ? this.$refs.uploadVideo.fileList[0].path : ''
      //   if (!this.viewData.thumb) {
      //     this.$message.warning('请上传视频');
      //     return
      //   }
      // }
      // console.log(this.viewData);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.viewData.ad_id) {
            // 编辑
            ad.bannerEdit(this.viewData).then((res) => {
              if (res.code == 200) {
                that.$message.success(res.message);
                that.$emit("onUpdateDrawer", 1);
                that.resetForm()
              } else {
                that.$message.error(res.message);
                that.$emit("onUpdateDrawer", -1);
              }
            });
          } else {
            // 新增
            ad.bannerCreate(this.viewData).then((res) => {
              if (res.code == 200) {
                that.$message.success(res.message);
                that.$emit("onUpdateDrawer", 1);
                that.resetForm()
              } else {
                that.$message.error(res.message);
                that.$emit("onUpdateDrawer", -1);
              }
            });
          }
        } else {
          this.$message.warning(this.$t("form.verifyMsg"));
        }
      });
    },
    /**
     * @name: 清空form
     * @return {*}
     * @desc:
     */
    resetForm () {
      this.showUpload = false;
      this.activeType = '1';
      this.imageDefaultList = '';
      this.videoDefaultList = [];
      this.thumbList = [];
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
